<div class="page-container">
  <p class="suggestion-info">Möchtest du die folgenden KI-generierten Lernkarten hinzufügen?</p>
  <app-flashcard-list [flashcards]="flashcards!" [hideDueDate]="true"></app-flashcard-list>
</div>

<div class="footer">
  <app-button [text]="'Lernkarten übernehmen (' + flashcards?.length + ')'" [loading]="isLoading" (clickEvent)="confirm()"></app-button>
</div>